import React from 'react';
import { formatDate, currencyFormat } from 'utilities/common';

import Action from './table.action';

const Table = ({ data }) => {
  if (!data) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">Journal not found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive px-0 table-overflow">
      <table
        className="table table-vcenter card-table datatable border-bottom"
        width="100%"
      >
        <thead>
          <tr>
            <th
              className="text-center border-end"
              style={{ whiteSpace: 'initial', width: '7%' }}
              rowSpan={2}
            >
              Tanggal
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '15%' }}
              rowSpan={2}
            >
              No Bukti
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '17%' }}
              rowSpan={2}
            >
              Keterangan
            </th>
            <th
              className=" border-end text-center"
              style={{ whiteSpace: 'initial', width: '5%' }}
              rowSpan={2}
            >
              Akun Kode
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '17%' }}
              rowSpan={2}
            >
              Nama Akun
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '18%' }}
              rowSpan={2}
            >
              Nama Hutang/Piutang
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '15%' }}
              colSpan={2}
            >
              Jumlah
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '3%' }}
              rowSpan={2}
            >
            </th>
          </tr>
          <tr>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '7.5%' }}
            >
              Debit
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '7.5%' }}
            >
              Kredit
            </th>
          </tr>
        </thead>
        <tbody className="bg-white graph">
          {data?.journals?.map((d, i) => (
            <tr key={i}>
              <td className="border-end" style={{width: '7%'}}>
                {d?.journal_id !== data?.journals[i-1]?.journal_id && (
                  <div className="table-col text-center">
                    <div className="text-ellipsis">
                      {formatDate(d?.journal?.entry_date, 'DD/MM/YYYY')}
                    </div>
                  </div>
                )}
              </td>
              <td className="border-end" style={{width: '15%'}}>
                {d?.journal_id !== data?.journals[i-1]?.journal_id && (
                  <div className="table-col">
                    <div className="text-ellipsis text-uppercase">
                      {d?.journal?.ref_code}
                    </div>
                  </div>
                )}
              </td>
              <td className="border-end" style={{width: '17%'}}>
                {d?.journal_id !== data?.journals[i-1]?.journal_id && (
                  <div className="table-col">
                    {d?.journal?.note !== '' ? (
                      <>
                        <div className="text-ellipsis">
                          {d?.journal?.note}
                        </div>
                        <small className="info">
                          {d?.journal?.transaction?.name}
                        </small>
                      </>
                    ): (
                      <div className="text-ellipsis">
                        {d?.journal?.transaction?.name}
                      </div>
                    )}
                  </div>
                )}
              </td>
              <td className="border-end" style={{width: '5%'}}>
                <div className="table-col text-center">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.coa?.code}
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '17%'}}>
                <div className="table-col">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.coa?.name}
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '18%'}}>
                {d?.journal_id !== data?.journals[i-1]?.journal_id && (
                  <div className="table-col">
                    <div className="text-ellipsis text-uppercase fw-semibold">
                      {d?.journal?.partner?.name}
                    </div>
                    <small className="info text-uppercase">
                      {d?.journal?.partner?.company_name}
                    </small>
                  </div>
                )}
              </td>
              <td className="border-end" style={{width: '7.5%'}}>
                <div className="table-col text-end">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.type === 'debit' ? currencyFormat(d?.nominal) : ''}
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '7.5%'}}>
                <div className="table-col text-end">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.type === 'credit' ? currencyFormat(d?.nominal) : ''}
                  </div>
                </div>
              </td>
              <td className="border-end text-center" style={{width: '3%'}}>
                {d?.journal_id !== data?.journals[i-1]?.journal_id && (
                  <Action data={d} />
                )}
              </td>
            </tr>
          ))}

          <tr className='border-bottom'>
            <td className='border-end' colSpan={6} style={{width: '79%'}}/>
            <td className="border-end" style={{width: '7.5%'}}>
              <div className="table-col text-end">
                <div className="text-ellipsis fw-semibold text-uppercase">
                  {currencyFormat(data?.summary?.total_debit)}
                </div>
              </div>
            </td>
            <td className="border-end" style={{width: '7.5%'}}>
              <div className="table-col text-end">
                <div className="text-ellipsis fw-semibold text-uppercase">
                  {currencyFormat(data?.summary?.total_credit)}
                </div>
              </div>
            </td>
            <td style={{width: '3%'}}/>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Table;
